import { apiGet, apiPost, apiPatch, apiDelete } from "./client";

export const NEWS_CATEGORIES = ["События", "Проекты", "Объявления", "Итоги"];

function queryString(params) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "")
      query.set(key, value);
  });
  return query.toString();
}

export const getNews = (params = {}) =>
  apiGet(`/news?${queryString(params)}`, {});
export const getNewsArticle = (id) =>
  apiGet(`/news/${encodeURIComponent(id)}`, {});
export const getAdminNews = (params = {}) =>
  apiGet(`/admin/news?${queryString(params)}`);
export const createNews = (body) => apiPost("/admin/news", body);
export const updateNews = (id, body) => apiPatch(`/admin/news/${id}`, body);
export const deleteNews = (id) => apiDelete(`/admin/news/${id}`);
